var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"bell\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3333 6.40097C14.3333 4.96854 13.7714 3.59478 12.7712 2.58191C11.771 1.56903 10.4145 1 9 1C7.58551 1 6.22896 1.56903 5.22876 2.58191C4.22857 3.59478 3.66667 4.96854 3.66667 6.40097C3.66667 12.7021 1 14.5024 1 14.5024H17C17 14.5024 14.3333 12.7021 14.3333 6.40097Z",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.538 18.103C10.3817 18.3758 10.1574 18.6023 9.88749 18.7597C9.61761 18.9171 9.31163 19 9.00018 19C8.68873 19 8.38275 18.9171 8.11287 18.7597C7.84299 18.6023 7.61868 18.3758 7.4624 18.103",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.db64b5acf779b2941b47b655bf80c950.svg";
export { ForwardRef as ReactComponent };